import React, { useEffect } from "react";
import { useSessionStore } from "../../store/session.store";
import { useLocation, useNavigate } from "react-router"; // Correct import
import { routePaths } from "../../constants/paths";
import { ROLES } from "../../constants";

/**
 * Checks for user's authorization
 */
export default function AuthLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSessionStore((state) => state.user);

  const adminAccessiblePages = [routePaths.register];

  useEffect(() => {
    if (adminAccessiblePages.includes(location.pathname)) {
      if (user?.designation?.toLowerCase() !== ROLES.ADMIN.toLowerCase()) {
        navigate(routePaths.dashboard, { replace: true });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, user, navigate]);

  return <>{children}</>;
}
